import React from 'react';
import './Header.css';

const Header = () =>{
    return(
        <div id="Div_Header_JSX" className="Div_Header_CSS">
            <img className="Img_HeadrBackgroundSVG_CSS" src="../files/bg-header-desktop.svg" alt="Header Background SVG" />
        </div>
    );

}

export default Header;